"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var tombacIcon_1 = require("../tombacIcon");
function SvgChevronSUp(props) {
    return (React.createElement("svg", tslib_1.__assign({ viewBox: "7 -4 10 24" }, props),
        React.createElement("path", { d: "M15.47 10.53a.75.75 0 001.06-1.06l-4-4a.75.75 0 00-1.06 0l-4 4a.75.75 0 001.06 1.06L12 7.06z", fill: "currentColor" })));
}
exports.default = tombacIcon_1.default('ChevronSUp')(SvgChevronSUp);
//# sourceMappingURL=ChevronSUp.js.map